import { render, staticRenderFns } from "./CamadasBase.vue?vue&type=template&id=44d450b6&lang=pug"
import script from "./CamadasBase.vue?vue&type=script&lang=js"
export * from "./CamadasBase.vue?vue&type=script&lang=js"
import style0 from "./CamadasBase.vue?vue&type=style&index=0&id=44d450b6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports